let getTranslateX;
const DOMMatrix = global.WebKitCSSMatrix || global.DOMMatrix || global.MSCSSMatrix;
if (global.getComputedStyle && DOMMatrix) {
  getTranslateX = (node) => {
    const transform = global.getComputedStyle(node, null).getPropertyValue('transform');
    return Number(new DOMMatrix(transform).m41);
  };
} else {
  getTranslateX = (node) => {
    // matrix(1, 0, 0, 1, -100, 0)
    const transform = global.getComputedStyle(node, null).getPropertyValue('transform');
    return Number(transform.match(/[+-]?\d+/g)[4]);
  };
}

export { getTranslateX };
